/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Spanish
export default {
    'fabric.atlassianSwitcher.switchTo': 'Cambiar a',
    'fabric.atlassianSwitcher.switchToTooltip': 'Cambiar a…',
    'fabric.atlassianSwitcher.recent': 'Recientes',
    'fabric.atlassianSwitcher.more': 'Más',
    'fabric.atlassianSwitcher.try': 'Pruébalo',
    'fabric.atlassianSwitcher.manageList': 'Administrar lista',
    'fabric.atlassianSwitcher.jiraProject': 'Proyecto Jira',
    'fabric.atlassianSwitcher.confluenceSpace': 'Espacio de Confluence',
    'fabric.atlassianSwitcher.people': 'Personas',
    'fabric.atlassianSwitcher.administration': 'Administración',
    'fabric.atlassianSwitcher.discoverMore': 'Descubrir más',
    'fabric.atlassianSwitcher.errorHeading': 'Algo ha ido mal',
    'fabric.atlassianSwitcher.errorText': 'Aunque nos encargamos de supervisar estos errores, no dudes en contactar con nosotros si se repiten después de actualizar la página.',
    'fabric.atlassianSwitcher.errorImageAltText': 'Ya hay un robot estropeado y varias personas manos a la obra.',
    'fabric.atlassianSwitcher.expand': 'Expandir',
};
//# sourceMappingURL=es.js.map